<template lang="pug">
  div(id="app" data-server-rendered="true")
    router-view
</template>
<script>
export default {
  
}
</script>
<style lang="scss">

</style>
